import React from "react";

export default function ML_Examples() {
  return (
    <div>
      <h1>ML_Examples</h1>
      <p>This is the ML_Examples component.</p>
    </div>
  );
}
